export const JOBS_DELETED_EVENT = "RealQueue/JobsDeleted";
